import { api } from 'boot/axios.js'

export async function query(ctx, queryParams = {}) {
  try {
    const response = await api({
      url: '/origins',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('items', response.data.items)
    return response
  } catch (e) {
    throw e
  }
}

